import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "about-page" }
const _hoisted_2 = { class: "about-story" }
const _hoisted_3 = { class: "about-wrap story-grid" }
const _hoisted_4 = { class: "story-copy" }
const _hoisted_5 = { class: "about-values" }
const _hoisted_6 = { class: "about-wrap" }
const _hoisted_7 = { class: "value-grid" }
const _hoisted_8 = { class: "about-process" }
const _hoisted_9 = { class: "about-wrap process-about-grid" }
const _hoisted_10 = { class: "about-contact-strip" }
const _hoisted_11 = { class: "about-wrap contact-strip-grid" }

import { ArrowRight, Check, Clock3, HeartHandshake, Ruler, ShieldCheck, Users } from "lucide-vue-next";
import "@/assets/styles/about.css";

export default /*@__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[23] || (_cache[23] = _createStaticVNode("<section class=\"about-hero-new\"><div class=\"about-wrap about-hero-grid\"><div class=\"about-hero-copy\"><span class=\"about-kicker\">Über unseren Betrieb</span><h1>Gutes Handwerk beginnt mit <em>Verantwortung.</em></h1><p>Wir sind ein regional verwurzelter Dachdeckerbetrieb für Menschen, die Wert auf klare Worte, saubere Arbeit und langlebige Lösungen legen.</p></div><div class=\"about-hero-image\"><img src=\"/images/home/team-v2.png\" alt=\"Unser Dachdecker-Team bei der gemeinsamen Projektplanung\"><div class=\"about-image-label\"><strong>Ein Team</strong><span>von der Beratung bis zur Abnahme</span></div></div></div></section><section class=\"about-numbers\"><div class=\"about-wrap number-grid\"><div><strong>15+</strong><span>Jahre Erfahrung</span></div><div><strong>420</strong><span>erfolgreiche Projekte</span></div><div><strong>6</strong><span>Kernleistungen</span></div><div><strong>1</strong><span>fester Ansprechpartner</span></div></div></section>", 2)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "about-kicker dark" }, "Was uns antreibt", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Ein Dach ist mehr als Material über dem Kopf.", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", null, "Es schützt, was Ihnen wichtig ist. Deshalb betrachten wir jedes Projekt mit der gleichen Sorgfalt – unabhängig davon, ob eine einzelne Undichtigkeit behoben oder ein komplettes Dach erneuert wird.", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", null, "Wir verbinden bewährte Handwerkstechniken mit zeitgemäßen Dachsystemen. Entscheidungen erklären wir verständlich, Termine planen wir realistisch und auf der Baustelle behandeln wir Ihr Zuhause mit Respekt.", -1)),
          _createVNode(_component_RouterLink, {
            to: "/leistungen",
            class: "about-link"
          }, {
            default: _withCtx(() => [
              _cache[0] || (_cache[0] = _createTextVNode("Unsere Leistungen entdecken ", -1)),
              _createVNode(_unref(ArrowRight))
            ]),
            _: 1
          })
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "story-image" }, [
          _createElementVNode("img", {
            src: "/images/home/handwerk-v2.png",
            alt: "Präzise Handwerksarbeit an einem Dachanschluss"
          })
        ], -1))
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "about-heading" }, [
          _createElementVNode("span", { class: "about-kicker light" }, "Unsere Haltung"),
          _createElementVNode("h2", null, "Woran Sie uns messen können.")
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("article", null, [
            _createVNode(_unref(Ruler)),
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "01", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Genau hinschauen", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("p", null, "Wir prüfen zuerst die Ursache und empfehlen dann die passende Lösung – nicht die größte.", -1))
          ]),
          _createElementVNode("article", null, [
            _createVNode(_unref(HeartHandshake)),
            _cache[9] || (_cache[9] = _createElementVNode("span", null, "02", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("h3", null, "Verlässlich bleiben", -1)),
            _cache[11] || (_cache[11] = _createElementVNode("p", null, "Klare Absprachen, ehrliche Aussagen und ein Ansprechpartner, der erreichbar bleibt.", -1))
          ]),
          _createElementVNode("article", null, [
            _createVNode(_unref(ShieldCheck)),
            _cache[12] || (_cache[12] = _createElementVNode("span", null, "03", -1)),
            _cache[13] || (_cache[13] = _createElementVNode("h3", null, "Sauber übergeben", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("p", null, "Wir dokumentieren unsere Arbeit und verlassen Baustellen so, wie wir sie selbst erwarten würden.", -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _cache[19] || (_cache[19] = _createElementVNode("div", null, [
          _createElementVNode("span", { class: "about-kicker dark" }, "Zusammenarbeit"),
          _createElementVNode("h2", null, "Persönlich statt anonym."),
          _createElementVNode("p", null, "Von der ersten Frage bis zur fertigen Übergabe wissen Sie, wer Ihr Projekt betreut.")
        ], -1)),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_unref(Check)),
            _cache[16] || (_cache[16] = _createElementVNode("div", null, [
              _createElementVNode("strong", null, "Vor-Ort-Termin"),
              _createElementVNode("span", null, "Wir hören zu und prüfen die Gegebenheiten.")
            ], -1))
          ]),
          _createElementVNode("li", null, [
            _createVNode(_unref(Check)),
            _cache[17] || (_cache[17] = _createElementVNode("div", null, [
              _createElementVNode("strong", null, "Klare Empfehlung"),
              _createElementVNode("span", null, "Sie verstehen Lösung, Umfang und Kosten.")
            ], -1))
          ]),
          _createElementVNode("li", null, [
            _createVNode(_unref(Check)),
            _cache[18] || (_cache[18] = _createElementVNode("div", null, [
              _createElementVNode("strong", null, "Koordinierte Umsetzung"),
              _createElementVNode("span", null, "Das Team arbeitet planvoll und hält Sie auf dem Laufenden.")
            ], -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", null, [
          _createVNode(_unref(Users)),
          _cache[20] || (_cache[20] = _createElementVNode("span", null, [
            _createElementVNode("strong", null, "Persönlich für Sie da"),
            _createTextVNode("Mo–Fr von 07:00 bis 17:00 Uhr")
          ], -1))
        ]),
        _createElementVNode("div", null, [
          _createVNode(_unref(Clock3)),
          _cache[21] || (_cache[21] = _createElementVNode("span", null, [
            _createElementVNode("strong", null, "Dringender Schaden?"),
            _createTextVNode("Schnelle Ersteinschätzung per Telefon")
          ], -1))
        ]),
        _createVNode(_component_RouterLink, { to: "/kontakt" }, {
          default: _withCtx(() => [
            _cache[22] || (_cache[22] = _createTextVNode("Gespräch vereinbaren ", -1)),
            _createVNode(_unref(ArrowRight))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})